import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { SessionService } from '../shared/services/session.service';
import { SessionModel } from './models/session-model';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss']
})
export class ShellComponent implements OnInit {
  private readonly subscription = new Subscription();

  constructor(
    private readonly route: ActivatedRoute,
    private readonly sessionService: SessionService) { }

  ngOnInit() {
    this.subscription.add(
      this.route.data.subscribe(
        (data: { model: SessionModel }) => {
          this.sessionService.setSessionId(data.model.sessionId);
        })
    );
  }
}
